import { WorkspacePickerScreen } from '@/features/settings/WorkspacePickerScreen';

/**
 * Shown when `VITE_WORKSPACE_ID` is absent or not a UUID.
 *
 * The shell still refuses to invent a tenant: it asks the server which
 * workspaces the signed-in user belongs to (`GET /me`, `GET /workspaces`),
 * opens the only one if there is exactly one, offers a picker when there are
 * several, and offers to create one when there are none. Guessing would mean
 * rendering one workspace's chrome around another's data — the client-side
 * shape of the tenancy bug CLAUDE.md §1.4 forbids on the server.
 */
export function NotConfigured() {
  return <WorkspacePickerScreen autoOpenSingle />;
}
